export default __webpack_public_path__ + "static/media/Pixentro3.92a123eb.png";